import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { CcsService } from '../../services/ccs.service';

export interface InteractiveCase {
  id: number;
  caseNo: number;
  location: string;
  duration: string;
  specialty: string;
  subSpecialty: string;
  explanation: string;
  scoring: string;
  clock_management: string;
}

@Injectable({
  providedIn: 'root'
})
export class InteractiveCasesService {

  constructor(private ccsService: CcsService) { }

  getInteractiveCases(): Observable<InteractiveCase[]> {
    // Use the real API instead of mock data
    return this.ccsService.getAllCases().pipe(
      map(cases => cases.map((caseData:any) => ({
        id: caseData.case_id,
        caseNo: caseData.case_id,
        location: caseData.setting || 'Not specified',
        duration: `${caseData.estimated_duration || 20} Minutes`,
        specialty: caseData.specialty || 'General',
        subSpecialty: caseData.sub_specialty || 'General',
        explanation: caseData.explanation || '',
        scoring: caseData.scoring || '',
        clock_management: caseData.clock_management || ''
      })))
    );
  }
  

  // Method to launch a case
  launchCase(caseId: number): Observable<boolean> {
    console.log(`Launching case with ID: ${caseId}`);
    // Implementation would depend on the application requirements
    return of(true).pipe(delay(300));
  }

  // Method to get explanation for a case
  getExplanation(caseId: number, sequenceId?: number): Observable<string> {
    console.log(`Getting explanation for case ID: ${caseId}, sequence ID: ${sequenceId || 'N/A'}`);
    // Implementation would depend on the application requirements
    return of(`This is the explanation for case ${caseId}`).pipe(delay(300));
  }

  // Get detailed case information by ID
  getCaseById(caseId: string): Observable<any> {
    return this.ccsService.getCaseDetails(caseId);
  }
} 